var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5713 10V17M10.5713 10V17M6.57129 6V17.8C6.57129 18.9201 6.57129 19.4798 6.78928 19.9076C6.98102 20.2839 7.28676 20.5905 7.66309 20.7822C8.09049 21 8.65028 21 9.7682 21H15.3744C16.4923 21 17.0513 21 17.4787 20.7822C17.855 20.5905 18.1618 20.2839 18.3535 19.9076C18.5713 19.4802 18.5713 18.921 18.5713 17.8031V6M6.57129 6H8.57129M6.57129 6H4.57129M8.57129 6H16.5713M8.57129 6C8.57129 5.06812 8.57129 4.60241 8.72353 4.23486C8.92652 3.74481 9.31561 3.35523 9.80566 3.15224C10.1732 3 10.6394 3 11.5713 3H13.5713C14.5032 3 14.9691 3 15.3367 3.15224C15.8267 3.35523 16.216 3.74481 16.4189 4.23486C16.5712 4.6024 16.5713 5.06812 16.5713 6M16.5713 6H18.5713M18.5713 6H20.5713",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.58f15c4e3270260b7e421b362fc7296e.svg";
export { ForwardRef as ReactComponent };